import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistreComponent } from './registre.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddRegistreComponent } from './add-registre/add-registre.component';
import { EditRegistreComponent } from './edit-registre/edit-registre.component';
import { ChangeCurrentNumberComponent } from './change-current-number/change-current-number.component';

@NgModule({
    declarations: [RegistreComponent, AddRegistreComponent, EditRegistreComponent, ChangeCurrentNumberComponent],
    imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
    exports: [RegistreComponent],
})
export class RegistreModule { }
